export function downloadFile (params)  {
    let url = `/td/api/download?name=${encodeURIComponent(params.name)}&path=${params.path}`
    try{
        const link = document.createElement('a');
        link.href = url;
        link.download = params.name;
        link.target = '_blank'; // 可选，如果想在新窗口中打开下载链接，请添加此行
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }catch(e){
        console.log('exportFile error',e);
    }
}
